/**
 * A simple to implement and integrate Angular image carousel, built with sensible CSS.
 * @version v0.1.1 - 2015-01-20
 * @link https://github.com/forwardadvance/higgidy_carousel
 * @author Nicholas Johnson - nicholas@forwardadvance.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
"use strict";

var cov_ok8d0beuu = function () {
  var path = "D:\\freelance\\giutien-viettel\\client-giutien\\src\\js\\higgidy_carousel.min.js",
      hash = "89e88f640d67a6357b180ab395eda6f497177efc",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "D:\\freelance\\giutien-viettel\\client-giutien\\src\\js\\higgidy_carousel.min.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 13
        },
        end: {
          line: 8,
          column: 1242
        }
      },
      "1": {
        start: {
          line: 8,
          column: 132
        },
        end: {
          line: 8,
          column: 567
        }
      },
      "2": {
        start: {
          line: 8,
          column: 181
        },
        end: {
          line: 8,
          column: 222
        }
      },
      "3": {
        start: {
          line: 8,
          column: 243
        },
        end: {
          line: 8,
          column: 280
        }
      },
      "4": {
        start: {
          line: 8,
          column: 302
        },
        end: {
          line: 8,
          column: 381
        }
      },
      "5": {
        start: {
          line: 8,
          column: 408
        },
        end: {
          line: 8,
          column: 440
        }
      },
      "6": {
        start: {
          line: 8,
          column: 468
        },
        end: {
          line: 8,
          column: 495
        }
      },
      "7": {
        start: {
          line: 8,
          column: 616
        },
        end: {
          line: 8,
          column: 819
        }
      },
      "8": {
        start: {
          line: 8,
          column: 692
        },
        end: {
          line: 8,
          column: 816
        }
      },
      "9": {
        start: {
          line: 8,
          column: 748
        },
        end: {
          line: 8,
          column: 781
        }
      },
      "10": {
        start: {
          line: 8,
          column: 820
        },
        end: {
          line: 8,
          column: 828
        }
      },
      "11": {
        start: {
          line: 8,
          column: 882
        },
        end: {
          line: 8,
          column: 1230
        }
      },
      "12": {
        start: {
          line: 8,
          column: 917
        },
        end: {
          line: 8,
          column: 1227
        }
      },
      "13": {
        start: {
          line: 8,
          column: 947
        },
        end: {
          line: 8,
          column: 978
        }
      },
      "14": {
        start: {
          line: 8,
          column: 979
        },
        end: {
          line: 8,
          column: 1049
        }
      },
      "15": {
        start: {
          line: 8,
          column: 1078
        },
        end: {
          line: 8,
          column: 1143
        }
      },
      "16": {
        start: {
          line: 8,
          column: 1231
        },
        end: {
          line: 8,
          column: 1239
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 112
          },
          end: {
            line: 8,
            column: 113
          }
        },
        loc: {
          start: {
            line: 8,
            column: 125
          },
          end: {
            line: 8,
            column: 568
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 170
          },
          end: {
            line: 8,
            column: 171
          }
        },
        loc: {
          start: {
            line: 8,
            column: 180
          },
          end: {
            line: 8,
            column: 223
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 8,
            column: 231
          },
          end: {
            line: 8,
            column: 232
          }
        },
        loc: {
          start: {
            line: 8,
            column: 242
          },
          end: {
            line: 8,
            column: 281
          }
        },
        line: 8
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 8,
            column: 291
          },
          end: {
            line: 8,
            column: 292
          }
        },
        loc: {
          start: {
            line: 8,
            column: 301
          },
          end: {
            line: 8,
            column: 382
          }
        },
        line: 8
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 8,
            column: 397
          },
          end: {
            line: 8,
            column: 398
          }
        },
        loc: {
          start: {
            line: 8,
            column: 407
          },
          end: {
            line: 8,
            column: 441
          }
        },
        line: 8
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 8,
            column: 457
          },
          end: {
            line: 8,
            column: 458
          }
        },
        loc: {
          start: {
            line: 8,
            column: 467
          },
          end: {
            line: 8,
            column: 496
          }
        },
        line: 8
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 8,
            column: 599
          },
          end: {
            line: 8,
            column: 600
          }
        },
        loc: {
          start: {
            line: 8,
            column: 609
          },
          end: {
            line: 8,
            column: 829
          }
        },
        line: 8
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 8,
            column: 676
          },
          end: {
            line: 8,
            column: 677
          }
        },
        loc: {
          start: {
            line: 8,
            column: 691
          },
          end: {
            line: 8,
            column: 817
          }
        },
        line: 8
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 8,
            column: 737
          },
          end: {
            line: 8,
            column: 738
          }
        },
        loc: {
          start: {
            line: 8,
            column: 747
          },
          end: {
            line: 8,
            column: 782
          }
        },
        line: 8
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 8,
            column: 865
          },
          end: {
            line: 8,
            column: 866
          }
        },
        loc: {
          start: {
            line: 8,
            column: 875
          },
          end: {
            line: 8,
            column: 1240
          }
        },
        line: 8
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 8,
            column: 903
          },
          end: {
            line: 8,
            column: 904
          }
        },
        loc: {
          start: {
            line: 8,
            column: 916
          },
          end: {
            line: 8,
            column: 1228
          }
        },
        line: 8
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 8,
            column: 930
          },
          end: {
            line: 8,
            column: 931
          }
        },
        loc: {
          start: {
            line: 8,
            column: 940
          },
          end: {
            line: 8,
            column: 1050
          }
        },
        line: 8
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 8,
            column: 1067
          },
          end: {
            line: 8,
            column: 1068
          }
        },
        loc: {
          start: {
            line: 8,
            column: 1077
          },
          end: {
            line: 8,
            column: 1144
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 196
          },
          end: {
            line: 8,
            column: 222
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 205
          },
          end: {
            line: 8,
            column: 220
          }
        }, {
          start: {
            line: 8,
            column: 221
          },
          end: {
            line: 8,
            column: 222
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 323
          },
          end: {
            line: 8,
            column: 381
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 323
          },
          end: {
            line: 8,
            column: 357
          }
        }, {
          start: {
            line: 8,
            column: 360
          },
          end: {
            line: 8,
            column: 380
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 8,
            column: 802
          },
          end: {
            line: 8,
            column: 816
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 802
          },
          end: {
            line: 8,
            column: 811
          }
        }, {
          start: {
            line: 8,
            column: 813
          },
          end: {
            line: 8,
            column: 816
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_ok8d0beuu.s[0];
angular.module("HiggidyCarousel", []).controller("HiggidyCarousel.controller", ["$scope", "$interval", function (a, b) {
  ++cov_ok8d0beuu.f[0];
  var c;++cov_ok8d0beuu.s[1];
  a.carousel = { current: 0, max: 0 }, a.setMax = function () {
    ++cov_ok8d0beuu.f[1];
    ++cov_ok8d0beuu.s[2];
    a.carousel.max = a.images ? (++cov_ok8d0beuu.b[0][0], a.images.length) : (++cov_ok8d0beuu.b[0][1], 1);
  }, a.show = function (b) {
    ++cov_ok8d0beuu.f[2];
    ++cov_ok8d0beuu.s[3];
    a.resetTimeout(), a.carousel.current = b;
  }, a.moveOn = function () {
    ++cov_ok8d0beuu.f[3];
    ++cov_ok8d0beuu.s[4];
    a.carousel.current++, (++cov_ok8d0beuu.b[1][0], a.carousel.current >= a.carousel.max) && (++cov_ok8d0beuu.b[1][1], a.carousel.current = 0);
  }, a.initTimeout = function () {
    ++cov_ok8d0beuu.f[4];
    ++cov_ok8d0beuu.s[5];
    c = b(a.moveOn, a.carousel.timeout);
  }, a.resetTimeout = function () {
    ++cov_ok8d0beuu.f[5];
    ++cov_ok8d0beuu.s[6];
    b.cancel(c), a.initTimeout();
  }, a.$watch("carousel.timeout", a.initTimeout), a.$watch("images", a.setMax);
}]).directive("higgidyCarousel", function () {
  ++cov_ok8d0beuu.f[6];
  var a = (++cov_ok8d0beuu.s[7], { controller: "HiggidyCarousel.controller", scope: !0, link: { pre: function pre(a, b, c) {
        ++cov_ok8d0beuu.f[7];
        ++cov_ok8d0beuu.s[8];
        a.carousel.width = b[0].offsetWidth, a.getWidth = function () {
          ++cov_ok8d0beuu.f[8];
          ++cov_ok8d0beuu.s[9];
          a.carousel.width = b[0].offsetWidth;
        }, a.carousel.timeout = (++cov_ok8d0beuu.b[2][0], c.timeout) || (++cov_ok8d0beuu.b[2][1], 1e3);
      } } });++cov_ok8d0beuu.s[10];
  return a;
}).directive("higgidyCarouselImages", function () {
  ++cov_ok8d0beuu.f[9];
  var a = (++cov_ok8d0beuu.s[11], { scope: !0, link: { post: function post(a, b) {
        ++cov_ok8d0beuu.f[10];
        ++cov_ok8d0beuu.s[12];
        a.setsWidths = function () {
          ++cov_ok8d0beuu.f[11];
          var c = (++cov_ok8d0beuu.s[13], a.carousel.width * a.carousel.max);++cov_ok8d0beuu.s[14];
          b.find("img").css({ width: a.carousel.width + "px" }), b.css({ width: c + "px" });
        }, a.animateScroll = function () {
          ++cov_ok8d0beuu.f[12];
          ++cov_ok8d0beuu.s[15];
          b.css({ "margin-left": 0 - a.carousel.width * a.carousel.current + "px" });
        }, a.$watch("carousel.max", a.setsWidths), a.$watch("carousel.current", a.animateScroll);
      } } });++cov_ok8d0beuu.s[16];
  return a;
});